import { ResizableWrapper } from '../../components/ResizableWrapper';
import { CSS_LINE_HEIGHT, Description } from '../../components/Description';
import { useGeneralInfo, useOffer } from '../../hooks';
import { clamp } from 'ramda';
import { useState, useCallback, useEffect } from 'react';

import useResizeObserver from 'use-resize-observer/polyfilled';

export function DescriptionContainer() {
  const { ref, height = 0 } = useResizeObserver();
  const [linesCount, setLinesCount] = useState<number | undefined>();
  const { description } = useGeneralInfo();
  const { isNewbuilding } = useOffer();

  const calcHeight = useCallback(() => {
    const maxLines = isNewbuilding ? 4 : 5;

    setLinesCount(clamp(0, maxLines, Math.floor(height / CSS_LINE_HEIGHT)));
  }, [height, isNewbuilding]);

  // пересчитываем максимальное количество строк описания
  useEffect(() => {
    calcHeight();
  }, [calcHeight]);

  if (!description || linesCount === 0) {
    return null;
  }

  return (
    <ResizableWrapper>
      <Description lines={linesCount} text={description} ref={ref} />
    </ResizableWrapper>
  );
}
